import { render, staticRenderFns } from "./SiteLogo.vue?vue&type=template&id=02233b38&scoped=true"
import script from "./SiteLogo.vue?vue&type=script&lang=js"
export * from "./SiteLogo.vue?vue&type=script&lang=js"
import style0 from "./SiteLogo.vue?vue&type=style&index=0&id=02233b38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02233b38",
  null
  
)

export default component.exports